/**
 * Lightweight image lightbox for gallery sections
 * No external dependency — uses a simple modal approach
 */

export function initGallery() {
  const galleryLinks = document.querySelectorAll('[data-lightbox="gallery"]');
  if (!galleryLinks.length) return;

  // Build lightbox modal once
  const modal = buildModal();
  document.body.appendChild(modal);

  const imgEl    = modal.querySelector('#lb-image');
  const caption  = modal.querySelector('#lb-caption');
  const prevBtn  = modal.querySelector('#lb-prev');
  const nextBtn  = modal.querySelector('#lb-next');
  const closeBtn = modal.querySelector('#lb-close');

  const items = Array.from(galleryLinks);
  let current = 0;

  const show = (index) => {
    current = (index + items.length) % items.length;
    const link = items[current];
    imgEl.src = link.href;
    imgEl.alt = link.getAttribute('aria-label') ?? '';
    caption.textContent = link.dataset.title ?? '';
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  };

  const hide = () => {
    modal.style.display = 'none';
    document.body.style.overflow = '';
    imgEl.src = '';
  };

  items.forEach((link, i) => {
    link.addEventListener('click', e => {
      e.preventDefault();
      show(i);
    });
  });

  prevBtn.addEventListener('click', () => show(current - 1));
  nextBtn.addEventListener('click', () => show(current + 1));
  closeBtn.addEventListener('click', hide);
  modal.addEventListener('click', e => { if (e.target === modal) hide(); });

  document.addEventListener('keydown', e => {
    if (modal.style.display !== 'flex') return;
    if (e.key === 'Escape')     hide();
    if (e.key === 'ArrowLeft')  show(current - 1);
    if (e.key === 'ArrowRight') show(current + 1);
  });
}

function buildModal() {
  const div = document.createElement('div');
  div.id = 'lightbox-modal';
  div.setAttribute('role', 'dialog');
  div.setAttribute('aria-modal', 'true');
  div.setAttribute('aria-label', 'Image viewer');
  div.style.cssText = `
    display:none; position:fixed; inset:0; z-index:9999;
    background:rgba(0,0,0,.92); align-items:center;
    justify-content:center; flex-direction:column;
  `;
  div.innerHTML = `
    <button id="lb-close" aria-label="Close"
      style="position:absolute;top:1rem;right:1.25rem;background:none;border:none;
             color:#fff;font-size:2rem;line-height:1;cursor:pointer;">&times;</button>
    <button id="lb-prev" aria-label="Previous"
      style="position:absolute;left:1rem;background:none;border:none;
             color:#fff;font-size:2.5rem;cursor:pointer;line-height:1;">&#8249;</button>
    <img id="lb-image" src="" alt=""
      style="max-height:80vh;max-width:90vw;object-fit:contain;border:2px solid rgba(255,255,255,.15);" />
    <p id="lb-caption"
      style="color:rgba(255,255,255,.7);margin-top:.75rem;font-size:.875rem;"></p>
    <button id="lb-next" aria-label="Next"
      style="position:absolute;right:1rem;background:none;border:none;
             color:#fff;font-size:2.5rem;cursor:pointer;line-height:1;">&#8250;</button>
  `;
  return div;
}
